<div class="maintenance">
    <div class="maintenance-message">
        <h2 class="mt-2 ml-2" style="color: red;">The application is under maintenance!</h2>
        <div style="margin-top: 70px;">
            <h3 class="mt-2 ml-2">We are currently performing scheduled maintenance. We
                apologize for any inconvenience this may cause.</h3>
        </div>
    </div>
</div>